<div class="panel-container">
  <div class="page-inner"><ng-content></ng-content></div>
</div>
